import Cookies from 'js-cookie';

const state = {
    access: Cookies.get('access') || '',
    refresh: Cookies.get('refresh') || '',
};

const mutations = {
    SET_ACCESS(state, access) {
        state.access = access;
        Cookies.set('access', access, { expires: 7 });
    },
    SET_REFRESH(state, refresh) {
        state.refresh = refresh;
        Cookies.set('refresh', refresh, { expires: 7 });
    },
    DELETE_DATA(state) {
        state.access = null;
        state.refresh = null;
        Cookies.remove('access');
        Cookies.remove('refresh');
    }
};

const actions = {
    setAccess({ commit }, access) {
        commit('SET_ACCESS', access);
    },
    setRefresh({ commit }, refresh) {
        commit('SET_REFRESH', refresh);
    },
    deleteData({ commit }) {
        commit('DELETE_DATA');
    }
};

const getters = {
    access: (state) => state.access,
    refresh: (state) => state.refresh,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
